/* eslint-disable no-undef */
import React, { useState } from 'react';
import { ContainerFormForStatusFooter, ContainerMenu } from '../../../../components/Containers';
import HeaderTitle from '../../../../components/HeaderTitle';
import { LineTableCND } from '../../../../components/NovoSistema/LineTableCND';
import { TableCND } from '../../../../components/NovoSistema/TableCND';
import WrapperButtonsLinks from '../../../../components/NovoSistema/WrapperButtonsLinks';

export default function TemplateCND() {
  const [year, setYear] = useState('21');
  return (
    <ContainerMenu>
      <ContainerFormForStatusFooter>
        <HeaderTitle text="CND - Certidão de Negativa de Débito" linkIcon="/images/icons/cdn.svg" />
        <WrapperButtonsLinks year={year} setYear={setYear} />
        <TableCND>
          <LineTableCND
            name="Certidão de regularidade fiscal municipal (CND municipal)"
            validate="31/12/2021"
            link="https://google.com"
          />
          <LineTableCND
            name="Certidão de regularidade fiscal estadual (CND estadual)"
            validate="31/12/2021"
            link="https://google.com"
          />
          <LineTableCND
            name="Certidão da Receita Federal (CND da Receita Federal)"
            validate="25/01/2022"
            link="https://google.com"
          />
          <LineTableCND
            name="Certidão de regularidade com relação ao FGTS (CND FGTS)"
            validate="15/02/2022"
            link="https://google.com"
          />
          <LineTableCND
            name="Certidão Negativa de Débitos Trabalhistas (CNDT)"
            validate="22/02/2022"
            link="https://google.com"
          />
          <LineTableCND
            name="Certidão Negativa de Tributos Mobiliários e Imobiliários"
            validate="01/03/2022"
            link="https://google.com"
          />
        </TableCND>
      </ContainerFormForStatusFooter>
    </ContainerMenu>
  );
}
